import { useState } from 'react';

export function ShowcaseSection() {
  const solutions = [
    {
      title: 'Innovation',
      description: 'Staying ahead with cutting-edge solutions that transform how businesses connect with the world',
      icon: 'ri-lightbulb-flash-line'
    },
    {
      title: 'Excellence',
      description: 'Delivering world-class quality in every project, exceeding expectations through dedication and expertise',
      icon: 'ri-award-line'
    },
    {
      title: 'Customer Focus',
      description: 'Putting clients first with tailored, practical, and results-driven solutions for sustainable growth',
      icon: 'ri-user-heart-line'
    },
    {
      title: 'Growth',
      description: 'Empowering businesses to achieve measurable success and long-term impact in the digital age',
      icon: 'ri-line-chart-line'
    }
  ];

  return (
    <section id="showcase" className="py-16 sm:py-20 md:py-24">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.1em]">
            Our Core Values
          </h2>
          <p className="text-gray-400 text-base sm:text-lg font-light max-w-3xl mx-auto px-4">
            The heartbeat of everything we do, guiding our creativity and defining how we work with our clients
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="group relative bg-black/30 backdrop-blur-sm border border-white/10 rounded-2xl p-6 sm:p-8 transition-all duration-500 hover:border-purple-400/50 hover:bg-black/40 hover:scale-105 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center mb-4 sm:mb-6 bg-gradient-to-br from-violet-500/20 to-purple-500/20 rounded-xl group-hover:from-violet-500/30 group-hover:to-purple-500/30 transition-all duration-300">
                <i className={`${solution.icon} text-2xl sm:text-3xl text-violet-400`}></i>
              </div>
              
              {/* Content */}
              <h3 className="text-xl sm:text-2xl font-light text-white mb-3 sm:mb-4 tracking-wide">
                {solution.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed font-light">
                {solution.description}
              </p>
              
              {/* Hover Effect Line */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-violet-400 to-purple-400 group-hover:w-full transition-all duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}